import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'gridHtmlIsFunc',
	pure: true,
	standalone: true
})
export class NHAGridHtmlIsFuncPipe implements PipeTransform {
	transform(html: string | number | (() => string | number)): boolean {
		return typeof html === 'function';
	}
}
